// Action Types
export const HIDE_PRODUCT_IN_SELECTOR = 'HIDE_PRODUCT_IN_SELECTOR';
export const SHOW_PRODUCT_IN_SELECTOR = 'SHOW_PRODUCT_IN_SELECTOR';
export const SET_VISIBLE_PRODUCTS = 'SET_VISIBLE_PRODUCTS';

// Action Creators
export const hideProductInSelector = (productId) => ({
    type: HIDE_PRODUCT_IN_SELECTOR,
    payload: productId
});

export const showProductInSelector = (productId) => ({
    type: SHOW_PRODUCT_IN_SELECTOR,
    payload: productId
});

export const setVisibleProducts = (productIds) => ({
    type: SET_VISIBLE_PRODUCTS,
    payload: productIds
});
